import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { AxiosRequestConfig, AxiosError } from 'axios';
import axios from 'axios';
import { camelCase, snakeCase } from 'lodash';
import { formatObjectKeys } from 'utilities/api';

type BaseQueryParams = {
  baseUrl?: string;
};

type QueryParams = {
  url: string;
  method?: AxiosRequestConfig['method'];
  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
  responseType?: AxiosRequestConfig['responseType'];
};

export const doRequest = async (
  { url, data, params, method = 'get', responseType = 'json' }: QueryParams,
  baseUrl = process.env.REACT_APP_API_BASE_URL,
) => {
  try {
    const result = await axios({
      url: `${baseUrl}${url}`,
      method,
      data: formatObjectKeys(data, snakeCase),
      params,
      responseType,
    });

    return result.data.data
      ? { data: formatObjectKeys(result.data.data, camelCase) }
      : result.data;
  } catch (axiosError) {
    const err = axiosError as AxiosError;
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};

const baseQuery =
  (
    { baseUrl }: BaseQueryParams = {
      baseUrl: process.env.REACT_APP_API_BASE_URL,
    },
  ): BaseQueryFn<QueryParams, unknown, unknown> =>
  async (params) =>
    doRequest(params, baseUrl);

export const basePath = (path: string): string =>
  `${process.env.REACT_APP_API_BASE_URL}${path}`;

export default baseQuery;
